import React from 'react';

const ResponsiveContext = React.createContext();

export const ResponsiveProvider = ResponsiveContext.Provider;
export const ResponsiveConsumer = ResponsiveContext.Consumer;
